import {REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK} from '/enum/records.enum';

export default {
  reportName: REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK,
};
